import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "48d4f3eb-fb55-4b40-87a4-84726198e67e", content: "Sound source position", options: {} },
  { id: "49d18b82-0d86-4b8a-b853-926637f1b2b4", content: "Listener location ", options: {} },
  { id: "c5f00335-3b99-4491-b328-6f83b7fcb2e6", content: "Individual anatomy of the listener", options: {} },
  { id: "3aa05230-59c6-40d2-9575-6aca2606014e", content: "Frequency of the source signal ", options: {} },
  { id: "2742454a-ab6f-47ed-bd42-a5fe76113ae3", content: "Level of the source signal ", options: {} },
  { id: "ee494a34-b2d4-4662-ac10-b20d0a86009f", content: "Temperature", options: {} },
];

export const task: Task = {
  id: "ffc3ffc4-c0fa-448e-ba29-e4369ffb7bc1",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "48d4f3eb-fb55-4b40-87a4-84726198e67e",
    "49d18b82-0d86-4b8a-b853-926637f1b2b4",
    "c5f00335-3b99-4491-b328-6f83b7fcb2e6",
  ],
};
